import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    setInterval(() => {
      this.element.textContent = new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true }) + " current time"
    }, 60000)
  }
}